module.exports = __webpack_public_path__ + "img/product-availability.38ac6b3d.jpg";